"use strict";
exports.__esModule = true;
exports.getTaxonByCode = exports.getTaxonByUuid = exports.getCategoryItemByCodePaths = exports.getCategoryItemByUuid = void 0;
var getCategoryItemByUuid = function (params) {
    var _a;
    var survey = params.survey, itemUuid = params.itemUuid;
    return (_a = survey.refData) === null || _a === void 0 ? void 0 : _a.categoryItemIndex[itemUuid];
};
exports.getCategoryItemByUuid = getCategoryItemByUuid;
var getCategoryItemByCodePaths = function (params) {
    var survey = params.survey, categoryUuid = params.categoryUuid, codePaths = params.codePaths;
    var itemUuid = codePaths.reduce(function (currentParentUuid, code) {
        var _a, _b, _c, _d;
        return currentParentUuid
            ? (_d = (_c = (_b = (_a = survey.refData) === null || _a === void 0 ? void 0 : _a.categoryItemUuidIndex) === null || _b === void 0 ? void 0 : _b[categoryUuid]) === null || _c === void 0 ? void 0 : _c[currentParentUuid]) === null || _d === void 0 ? void 0 : _d[code]
            : undefined;
    }, 'null');
    return itemUuid ? (0, exports.getCategoryItemByUuid)({ survey: survey, itemUuid: itemUuid }) : undefined;
};
exports.getCategoryItemByCodePaths = getCategoryItemByCodePaths;
var getTaxonByUuid = function (params) {
    var _a, _b;
    var survey = params.survey, taxonUuid = params.taxonUuid;
    return (_b = (_a = survey.refData) === null || _a === void 0 ? void 0 : _a.taxonIndex) === null || _b === void 0 ? void 0 : _b[taxonUuid];
};
exports.getTaxonByUuid = getTaxonByUuid;
var getTaxonByCode = function (params) {
    var _a, _b, _c;
    var survey = params.survey, taxonomyUuid = params.taxonomyUuid, taxonCode = params.taxonCode;
    var taxonUuid = (_c = (_b = (_a = survey.refData) === null || _a === void 0 ? void 0 : _a.taxonUuidIndex) === null || _b === void 0 ? void 0 : _b[taxonomyUuid]) === null || _c === void 0 ? void 0 : _c[taxonCode];
    return taxonUuid ? (0, exports.getTaxonByUuid)({ survey: survey, taxonUuid: taxonUuid }) : undefined;
};
exports.getTaxonByCode = getTaxonByCode;
//# sourceMappingURL=refsData.js.map